import {
    FETCH_MESSAGE_COUNTER_BEGIN,
    FETCH_MESSAGE_COUNTER_FAILURE,
    FETCH_MESSAGE_COUNTER_SUCCESS
} from "../action/MessageCounterAction";


const initialState = {
    messageCount: 0,
    loading: false,
    error: null
};

export default function MessageCounterReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_MESSAGE_COUNTER_BEGIN:
            return {
                ...state,
                loading: true,
                error: null
            };

        case FETCH_MESSAGE_COUNTER_SUCCESS:
            return {
                ...state,
                loading: false,
                messageCount: action.payload.messageCount,
            };

        case FETCH_MESSAGE_COUNTER_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                messageCount: 0,
            };
        default:
            return state;
    }
}
